<template>
  <div class="mt-4 ml-5 mr-5">
    <fullscreen background="#FFF" ref="fullscreen" @change="fullscreenChange">
      <v-layout class="ma-0 pa-0">
        <v-flex xs3 left>
          <h2>No Moving</h2>
        </v-flex>
        <v-flex xs1 left>
          <button title="Modo de Apresentação" type="button" @click="toggle">
            <v-icon
              large
              class="mdi"
              :class="[fullscreen ? 'mdi-fullscreen-exit' : 'mdi-fullscreen']"
            ></v-icon>
          </button>
        </v-flex>
        <v-flex class="ml-4" xs4>
          <v-autocomplete
            v-model="selects.fornecedores.value"
            :items="selects.fornecedores.items"
            label="Selecione Fornecedor"
            item-value="idfornecedor"
            item-text="razao_social"
            height="10"
            clearable
            outlined
            dense
            @change="buscarAnaliseFinanceiro()"
          ></v-autocomplete>
        </v-flex>
        <v-flex class="ml-4" xs4>
          <!-- <v-select
            v-model="selects.tipoRelatorio.value"
            :items="selects.tipoRelatorio.items"
            dense
            label="Selecione Tipo Relatório"
            height="10"
            outlined
            autofocus
            item-value="tipo"
            item-text="tipoDesc"
            @change="buscarAnaliseFinanceiro()"
          ></v-select> -->

          <v-select
            v-model="selects.compradores.value"
            :items="selects.compradores.items"
            label="Selecione Comprador (es)"
            item-text="nome_completo"
            item-value="id"
            height="10"
            outlined
            multiple
            dense
            @change="verificaTodos()"
            @blur="
              buscarAnaliseFinanceiro();
              atualizarChart++;
            "
          >
            <template v-slot:selection="{ item, index }">
              <div class="item-select-comp">
                <span v-if="index === 0">{{ item.nome_completo }}</span>
                <span v-if="index === 1" class="grey--text caption">
                  &nbsp;(+{{ selects.compradores.value.length - 1 }} outros)
                </span>
              </div>
            </template>
          </v-select>
        </v-flex>
        <v-flex class="ml-4" xs2 v-if="selects.tipoRelatorio.value != 2">
          <v-select
            v-model="selects.filiais.value"
            :items="selects.filiais.items"
            dense
            label="Selecione a Filial"
            height="10"
            outlined
            autofocus
            item-value="filial"
            item-text="descricao"
            @change="buscarAnaliseFinanceiro()"
          ></v-select>
        </v-flex>
        <v-flex class="ml-4" xs3>
          <v-select
            v-model="selects.statusFiltro.value"
            :items="selects.statusFiltro.items"
            dense
            label="Selecione o Status"
            height="10"
            outlined
            autofocus
            item-value="status"
            item-text="name"
            @change="buscarAnaliseFinanceiro()"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout
        v-if="selects.tipoRelatorio.value === 1"
        style="margin-top: -45px"
      >
        <v-flex xs12>
          <ChartAnaliseFinanceira
            id="chart-financeiro-responsivo"
            :filial="filial"
            :fornecedor="fornecedor"
            :status="status"
            :compradores="selects.compradores.value"
            :atualizar="atualizarChart"
          />
        </v-flex>
      </v-layout>
      <v-layout style="margin-top: -25px; margin-bottom: 30px" v-else>
        <v-flex xs10>
          <ChartAnaliseFinanceiraFiliais
            class="altura-responsiva-grafico-indicador"
            :filial="filial"
            :fornecedor="fornecedor"
            :status="status"
            :tipoRelatorio="selects.tipoRelatorio.value"
          />
        </v-flex>
        <v-flex xs2 class="ma-4">
          <p v-for="(item, i, p) in desserts" :key="i">
            <span
              class="dot-square"
              :style="{ backgroundColor: cores[p] }"
            ></span>
            Filial {{ item[1].filial }}
          </p>
        </v-flex>
      </v-layout>
      <v-layout style="margin-top: 15px">
        <v-flex xs12>
          <v-simple-table
            dense
            class="pa-2 elevation-2 simple-table-indicadores"
          >
            <template v-slot:default>
              <thead>
                <th style="width: 11%" v-if="selects.tipoRelatorio.value === 1">
                  Nível de Importância
                </th>
                <th style="width: 11%" v-else>Filial</th>
                <th style="width: 7.5%">Até 1 mês</th>
                <th style="width: 9%">De 1 a 2 meses</th>
                <th style="width: 9%">De 2 a 3 meses</th>
                <th style="width: 9%">De 3 a 6 meses</th>
                <th style="width: 9.5%">De 6 a 9 meses</th>
                <th style="width: 9.5%">De 9 a 12 meses</th>
                <th style="width: 9.5%">Mais de 12 meses</th>
                <th style="width: 11%">Sem Comportamento</th>
                <th style="width: 8%">Itens Novos</th>
                <th style="width: 7%">Total</th>
              </thead>
              <tbody
                v-if="selects.tipoRelatorio.value === 1"
                class="width-col"
                style="cursor: pointer"
              >
                <tr>
                  <td class="font-weight-bold">NÍVEL ELEVADO</td>
                  <td
                    v-for="(item, index) in desserts.elevado || arrayDefault"
                    :key="index"
                    @click="organizarDadosParaDialogGeral(item)"
                  >
                    {{ Helpers.formatarValorMonetario(item.total) }}
                  </td>
                  <td>
                    {{ Helpers.formatarValorMonetario(total.elevado || 0) }}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">NÍVEL ALTO</td>
                  <td
                    v-for="(item, index) in desserts.alto || arrayDefault"
                    :key="index"
                    @click="organizarDadosParaDialogGeral(item)"
                  >
                    {{ Helpers.formatarValorMonetario(item.total) }}
                  </td>
                  <td>{{ Helpers.formatarValorMonetario(total.alto || 0) }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">NÍVEL MÉDIO</td>
                  <td
                    v-for="(item, index) in desserts.medio || arrayDefault"
                    :key="index"
                    @click="organizarDadosParaDialogGeral(item)"
                  >
                    {{ Helpers.formatarValorMonetario(item.total) }}
                  </td>
                  <td>
                    {{ Helpers.formatarValorMonetario(total.medio || 0) }}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">NÍVEL BAIXO</td>
                  <td
                    v-for="(item, index) in desserts.baixo || arrayDefault"
                    :key="index"
                    @click="organizarDadosParaDialogGeral(item)"
                  >
                    {{ Helpers.formatarValorMonetario(item.total) }}
                  </td>
                  <td>
                    {{ Helpers.formatarValorMonetario(total.baixo || 0) }}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">NÍVEL ORDINÁRIO</td>
                  <td
                    v-for="(item, index) in desserts.ordinario || arrayDefault"
                    :key="index"
                    @click="organizarDadosParaDialogGeral(item)"
                  >
                    {{ Helpers.formatarValorMonetario(item.total) }}
                  </td>
                  <td>
                    {{ Helpers.formatarValorMonetario(total.ordinario || 0) }}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">SOB ENCOMENDA</td>
                  <td
                    v-for="(item, index) in desserts.encomenda || arrayDefault"
                    :key="index"
                    @click="organizarDadosParaDialogGeral(item)"
                  >
                    {{ Helpers.formatarValorMonetario(item.total) }}
                  </td>
                  <td>
                    {{ Helpers.formatarValorMonetario(total.encomenda || 0) }}
                  </td>
                </tr>
                <tr class="font-weight-bold">
                  <td>TOTALIZADOR</td>
                  <td>{{ Helpers.formatarValorMonetario(total.grupo_1) }}</td>
                  <td>{{ Helpers.formatarValorMonetario(total.grupo_2) }}</td>
                  <td>{{ Helpers.formatarValorMonetario(total.grupo_3) }}</td>
                  <td>{{ Helpers.formatarValorMonetario(total.grupo_4) }}</td>
                  <td>{{ Helpers.formatarValorMonetario(total.grupo_5) }}</td>
                  <td>{{ Helpers.formatarValorMonetario(total.grupo_6) }}</td>
                  <td>{{ Helpers.formatarValorMonetario(total.grupo_7) }}</td>
                  <td>
                    {{ Helpers.formatarValorMonetario(total.grupo_8) }}
                  </td>
                  <td>
                    {{ Helpers.formatarValorMonetario(total.grupo_9) }}
                  </td>
                  <td>
                    {{ Helpers.formatarValorMonetario(total.geral || 0) }}
                  </td>
                </tr>
              </tbody>
              <tbody v-else class="width-col" style="cursor: pointer">
                <tr v-for="(item, index) in desserts" :key="index">
                  <td class="font-weight-bold">Filial {{ item[1].filial }}</td>
                  <td
                    v-for="(subItem, i) in item"
                    :key="i"
                    @click="organizarDadosParaDialogGeral(subItem)"
                  >
                    {{ Helpers.formatarValorMonetario(subItem.total) }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-flex>
      </v-layout>
      <!-- ABRE O DIALOG DE EXPORTAÇÃO DE RELATORIOS -->
      <v-layout justify-center>
        <dialog-relatorios
          :cardRelatorio="cardRelatoriosSelecionado"
          @defaultCard="cardRelatoriosSelecionado = $event"
        ></dialog-relatorios>
      </v-layout>
    </fullscreen>
  </div>
</template>
<script>
import IndicadoresAPI from "../../../api/indicadores";
import ChartAnaliseFinanceira from "./ChartAnaliseFinaceira.vue";
import ChartAnaliseFinanceiraFiliais from "./ChartAnaliseFinanceiraFiliais.vue";
import DrpAPI from "../../../api/drp";
import { mapGetters } from "vuex";
import dialogRelatorios from "../../layout/dialogRelatorios.vue";
import ConfigAPI from "../../../api/cfg";
import $axios from '../../../api/api.js'

export default {
  name: "SlowMovingExcesso",

  components: {
    ChartAnaliseFinanceira,
    ChartAnaliseFinanceiraFiliais,
    dialogRelatorios,
  },

  data() {
    return {
      fullscreen: false,
      desserts: [],
      filial: "Todas",
      fornecedor: "",
      status: "",
      extencaoRelatorio: "EXCEL",
      cores: ["#FFBF05", "#451145", "#00AE51", "#0071C1", "#0D0D0D"],
      atualizarChart: 0,

      selects: {
        filiais: {
          items: [],
          value: 9999,
        },
        fornecedores: {
          items: [],
          value: "0",
        },
        compradores: {
          items: [],
          value: [],
        },
        statusFiltro: {
          items: [
            { name: "Todos", status: "Todos" },
            { name: "Itens em Excesso", status: "EXCESSO" },
            { name: "Itens Ativos", status: "ATIVO" },
            { name: "Itens Inativos", status: "INATIVO" },
            { name: "Itens Fora de Linha", status: "FL" },
          ],
          value: "Todos",
        },
        tiposRelatorio: {
          items: [{ tipo: "PDF" }, { tipo: "EXCEL" }],
        },
        tipoRelatorio: {
          items: [
            { tipo: 1, tipoDesc: "Nível de Importância" },
            // {tipo: 2, tipoDesc: 'Financeiro'},
          ],
          value: 1,
        },
      },

      //para uso no dialog de uso geral
      CardNivelImportancia: {
        titulo: "Relatório Nível de Importância",
        ativo: false,
        headers: [
          { text: "Filial", value: "filial_perda_venda", align: "left" },
          { text: "Id Fabricante", value: "id_fornecedor" },
          { text: "Razão Social", value: "razao_social" },
          { text: "", value: "dialog_detalhes_produtos", width: '5px', class: 'pa-0 ma-0', cellClass: 'pa-0 ma-0' },
          { text: "Id Produto", value: "idproduto" },
          { text: "Descrição Produto", value: "descricao_produto" },
          // { text: "Data Cadastro", value: "data_cadastro" },
          { text: "Última Entrada", value: "data_entrega" },
          { text: "Última Saída", value: "ult_saida" },
          { text: "Estoque", value: "estoque" },
          { text: "Produtos Vencidos", value: "qtde_vencidos" },
          // { text: "Estoque Segurança", value: "estoque_seguranca" },
          // { text: "Ponto de Pedido", value: "ponto_pedido" },
          // { text: "Estoque Máximo", value: "estoque_maximo" },
          { text: "Custo Unitário", value: "custo_unitario" },
          { text: "Total", value: "total" },
          { text: "", value: "data-table-expand", sortable: false },
        ],
        itens: [],
        info: "",
        filtros: {
          grupo: '',
          filial: "",
          fornecedor: "",
          status: "",
          tipoRelatorio: "",
          grupo_venda: "",
          nivel_servico: "",
          filial_financeiro: "",
          compradores: [],
        },
        url: "relatorio_nivel_importancia",
        metodo: 9,
      },
      cardRelatoriosSelecionado: {},
      total: {
        grupo_1: 0,
        grupo_2: 0,
        grupo_3: 0,
        grupo_4: 0,
        grupo_5: 0,
        grupo_6: 0,
        grupo_7: 0,
        grupo_8: 0,
        grupo_9: 0,
        geral: 0,
      },
      arrayDefault: [0, 0, 0, 0, 0, 0, 0, 0],
    };
  },

  computed: {
    ...mapGetters({
      grupoCompra: "usuario/getGrupoCompras",
    }),
  },

  watch: {
    grupoCompra() {
      this.buscarFiliais();
      this.buscarAnaliseFinanceiro();
    },
  },

  created() {
    this.buscarAnaliseFinanceiro();
    this.buscarFiliais();
    this.buscarFornecedores();
    this.buscarCompradores();
  },

  methods: {
    verificaTodos() {
      const length = this.selects.compradores.value.length;

      if (length == 0) {
        this.selects.compradores.value = [0];
        return 0;
      }

      const selecionados = this.selects.compradores.value.filter(
        (item) => item > 0
      );

      const ult = this.selects.compradores.value[length - 1];

      if (ult === 0) {
        this.selects.compradores.value = [0];
      } else {
        this.selects.compradores.value = selecionados;
      }
    },

    buscarCompradores() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        ConfigAPI.getCompradores(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
            this.selects.compradores.value = [0];

            this.selects.compradores.items = response.data.compradores;

            this.selects.compradores.items.unshift({
              id: 0,
              nome_completo: "Todos",
            });
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    totais() {
      this.total = {
        grupo_1: 0,
        grupo_2: 0,
        grupo_3: 0,
        grupo_4: 0,
        grupo_5: 0,
        grupo_6: 0,
        grupo_7: 0,
        grupo_8: 0,
        grupo_9: 0,
        geral: 0,
      };

      let i = 0;

      while (i < 6) {
        let keyValues = Object.keys(this.desserts);
        let keyValue = Object.keys(this.desserts[keyValues[i]]);
        let c = 0;

        while (c < 9) {
          if (this.desserts[keyValues[i]][keyValue[c]]) {
            let keyGrupo = "grupo_".concat(parseInt(c) + 1);

            let value = this.desserts[keyValues[i]][keyValue[c]].total;

            this.total[keyGrupo] += parseInt(value);
          }

          c++;
        }
        i++;
      }

      // total geral e por linha
      Object.keys(this.desserts).forEach((item) => {
        const totalGeral = (a, b) => parseFloat(a) + parseFloat(b["total"]);
        this.total[item] = Object.values(this.desserts[item]).reduce(
          totalGeral,
          0
        );
        this.total.geral += this.total[item];
      });
    },

    organizarDadosParaDialogGeral(item) {
      if (item.total > 0) {
        const compradores = this.selects.compradores.value;

        this.CardNivelImportancia.filtros.grupo = this.grupoCompra;
        this.CardNivelImportancia.filtros.filial = this.selects.filiais.value;
        this.CardNivelImportancia.filtros.fornecedor = this.selects.fornecedores.value;
        this.CardNivelImportancia.filtros.status = this.selects.statusFiltro.value;
        this.CardNivelImportancia.filtros.compradores =
          compradores[0] != 0 ? compradores : [];

        this.CardNivelImportancia.filtros.tipoRelatorio = this.selects.tipoRelatorio.value;
        this.CardNivelImportancia.filtros.grupo_venda = item.grupo_venda;

        if (this.selects.tipoRelatorio.value == 1) {
          this.CardNivelImportancia.filtros.nivel_servico = item.nivel_servico;
          this.CardNivelImportancia.filtros.filial_financeiro = "";
        } else {
          this.CardNivelImportancia.filtros.filial_financeiro = item.filial;
          this.CardNivelImportancia.filtros.nivel_servico = "";
        }

        this.cardRelatoriosSelecionado = this.CardNivelImportancia;
      } else {
        alert("Dados insuficientes para gerar relatório.");
      }
    },

    buscarFornecedores() {
      if (this.selects.fornecedores.items == "") {
        const headers = this.Helpers.iniciarRequisicao();

        this.selects.fornecedores.items = [];

        this.$store.dispatch(
          "loading/addRequisicao",
          DrpAPI.getFornecedores(headers)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              const forn = response.data.fornecedores;

              this.selects.fornecedores.items.push({
                idfornecedor: 0,
                razao_social: "Todos",
              });

              forn.forEach((fornecedor) => {
                fornecedor.razao_social =
                  fornecedor.idfornecedor + " - " + fornecedor.razao_social;

                this.selects.fornecedores.items.push(fornecedor);
              });

              this.selects.fornecedores.value = 0;
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },

    buscarFiliais() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.grupoCompra,
      };

      this.selects.filiais.items = [];
      this.selects.filiais.value = [];

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.getFiliaisDrp(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            this.selects.filiais.items.push({ filial: 9999, descricao: "Todas" });

            const filiais = response.data.filiais;

            filiais.forEach((filial) => {
              this.selects.filiais.items.push(filial);
            });

            this.selects.filiais.value = this.selects.filiais.items[0].filial;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    buscarAnaliseFinanceiro() {
      this.desserts = [];
      this.total = {};

      const headers = this.Helpers.iniciarRequisicao();

      const compradores = this.selects.compradores.value;

      const params = {
        grupo: this.grupoCompra,
        fornecedor: this.selects.fornecedores.value,
        filial: this.selects.filiais.value,
        status: this.selects.statusFiltro.value,
        tipo_analise: this.selects.tipoRelatorio.value,
        compradores: compradores[0] != 0 ? compradores : [],
      };

      this.filial = this.selects.filiais.value;
      this.fornecedor =
        this.selects.fornecedores.value != this.fornecedor
          ? this.selects.fornecedores.value
          : this.fornecedor;
      this.status = this.selects.statusFiltro.value;

      this.$store.dispatch(
        "loading/addRequisicao",
        IndicadoresAPI.getAnaliseFinanceiro(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.desserts = response.data.financeiro;
              this.totais();
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    exportarExcel() {
      let url = "relatorio_nivel_importancia";
      url += "?tipoR=EXPORTACAO_EXCEL";
      url += "&grupo=" + this.grupoCompra;
      url += "&filial=" + this.selects.filiais.value;
      url += "&status=" + this.selects.statusFiltro.value;
      url += "&tipoRelatorio=" + this.selects.tipoRelatorio.value;

      if (this.selects.fornecedores.value >= 0) {
        url += "&fornecedor=" + this.selects.fornecedores.value;
      }

      window.open($axios.defaults.baseURL+ "/" + url, "_blank");
    },

    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },

    toggle() {
      this.$refs["fullscreen"].toggle();
    },
  },
};
</script>
<style scoped>
.dot-square {
  height: 15px;
  width: 20px;
  border-radius: 15%;
  display: inline-block;
}

table,
th,
td {
  font-size: 12px;
}

.width-col {
  overflow-x: scroll;
  white-space: nowrap;
}

.width-col tr td {
  width: 161px;
}

.niveis-importancia p {
  margin: 10px;
}
.item-select-comp {
  display: flex;
}
.mais-selecionados {
  font-size: 11px;
  margin-left: 5px;
  color: #777;
}
</style>

<style>
#chart-financeiro-responsivo {
  height: calc(100vh - 385px) !important;
}
</style>
